module.exports = __webpack_public_path__ + "static/media/sake_red.59043dcb.webp";